import type { SearchMovieResult, SearchSeriesResult } from "@/types/search";
import type { PersonContent } from "@/types/person";

function pickPoster(
  medias?: { media_type?: string; media_url?: string; is_primary?: boolean }[] | null,
): string {
  if (!medias?.length) return "";
  // Always prefer the desktop poster: the API often flags a backdrop as
  // is_primary, so keying off is_primary here shows a wide backdrop where a
  // poster-shaped image is expected.
  const poster =
    medias.find((m) => m.media_type === "poster_desktop") ??
    medias.find((m) => m.media_type?.startsWith("poster")) ??
    medias.find((m) => m.is_primary) ??
    medias[0];
  return poster?.media_url ?? "";
}

export function mapSearchMovieToContent(movie: SearchMovieResult): PersonContent {
  return {
    content_type: "movie",
    entity_type: "movie",
    unique_code: movie.unique_code || movie.uuid,
    content_uuid: movie.uuid,
    poster_url: pickPoster(movie.Medias),
    title_fa: movie.title_fa || "",
    title_en: movie.title_en || "",
    release_date: movie.release_date,
    tags: movie.Tags ?? undefined,
    has_subtitles: movie.has_subtitles ?? null,
    has_dubbing: movie.has_dubbing ?? null,
    categories: movie.Categories?.map((c) => ({
      uuid: c.uuid,
      name_fa: c.name_fa,
      slug: c.slug,
    })),
  };
}

export function mapSearchSeriesToContent(series: SearchSeriesResult): PersonContent {
  return {
    content_type: "series",
    entity_type: "series",
    unique_code: series.unique_code || series.uuid,
    content_uuid: series.uuid,
    poster_url: pickPoster(series.Medias),
    title_fa: series.title_fa || "",
    title_en: series.title_en || "",
    release_date: series.release_date,
    tags: series.Tags ?? undefined,
    has_subtitles: series.has_subtitles ?? null,
    has_dubbing: series.has_dubbing ?? null,
    categories: series.Categories?.map((c) => ({
      uuid: c.uuid,
      name_fa: c.name_fa,
      slug: c.slug,
    })),
  };
}
